<template>
    <div>
  
      <Dialog :visible.sync="exibirModal" :header="titulo" :modal="true" :style="{width: '40vw'}" @hide="fechar">    
        <div v-if="itemPendente">    
            <label class="p-text-bold">{{ dados.solicitacao.funcionario.nomecc }}</label>
            <hr>
            <div class="p-fluid p-formgrid p-grid"> 
                <div class="p-field p-col-6">
                    <label>Data da Solicitação</label>
                    <InputText class="input-readonly" v-model="dados.solicitacao.data" readonly/>
                </div>
                <div class="p-field p-col-6">
                    <label>Data do Ponto <span class="p-text-bold" v-if="alteracao">(Editado)</span></label>
                    <InputText class="input-readonly" v-model="dados.solicitacao.dataPonto" readonly/>	
                </div> 
                <div class="p-field p-col-12 p-md-12" v-if="novo">
                    <label>Justificativa</label>
                    <InputText class="input-readonly" v-model.trim="itemPendente.justificativa.descricao" readonly/>
                </div>                 
            </div>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12">
                    <label>Abrangência</label>
                    <InputText class="input-readonly" v-model="abrangencias1" readonly/>				
                </div>
            </div>

            <div class="p-fluid p-formgrid p-grid" v-if="alteracao">
                <div class="p-field p-col-12 p-mt-3 p-mb-0">
                  <hr class="p-mt-0">
                </div>
                <div class="p-field p-col-6">
                    <label>Data do Ponto <span class="p-text-bold">(Novo)</span></label>
                    <InputText class="input-readonly" v-model="dataPontoAlteracao" readonly/>	
                </div> 
                <div class="p-field p-col-12 p-md-6">
                    <label>Justificativa</label>
                    <InputText class="input-readonly" v-model.trim="itemPendente.justificativa.descricao" readonly/>
                </div>
                <div class="p-field p-col-12 p-md-12">
                    <label>Abrangência</label>
                    <InputText class="input-readonly" v-model="abrangencias2" readonly/>				
                </div> 
            </div>
            
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12">
                    <label class="p-text-bold">Ação</label>
                    <Dropdown v-model="acaoSelecionada" :options="acoes" optionLabel="nome" 
                    optionValue="id" placeholder="Selecione" appendTo="body" 
                    :disabled="!exibirBotoes" :class="!exibirBotoes ? 'input-readonly' : ''"/>
                </div> 
                <div class="p-field p-col-12 p-md-12" v-if="acaoSelecionada == naoAprovado">
                    <label class="p-text-bold">Observação</label>
                    <Textarea v-model.trim="observacaoNaoAprovado" rows="3" cols="30" 
                    :class="!exibirBotoes ? 'input-readonly' : ''" :disabled="!exibirBotoes"/>
                </div>                                 
            </div>        
        </div>
        <template #footer>
            <div class="p-d-flex p-jc-end">
                <div v-if="exibirBotoes">
                    <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirModal = false"/>
                    <Button label="Salvar" icon="pi pi-check" @click="salvar"/>                      
                </div>                              
            </div>            
        </template>        
      </Dialog>

    </div>
  </template>
  
  <script>
  import OcorrenciaService from '@/service/OcorrenciaService.js';
  import ControlePontoService from '@/service/ControlePontoService.js';
  import { exibirMensagemSis, exibirMensagem, acoesSolicitacoesPendentes, clonar } from '@/global';
  import { mapGetters } from 'vuex';
  
  export default {  
      ocorrenciaService: null,
      controlePontoService: null,
      props: {
          callback: Function,
      },
      data() {
          return {  
            titulo: 'Solicitação',
            naoAprovado: 'Não Aprovado',   
            exibirModal: false,             
            itemPendente: null,          
            observacaoNaoAprovado: '',
            dados: null,
            acaoSelecionada: '',         
            acoes: acoesSolicitacoesPendentes,   
            exibirBotoes: false,
            novo: false,     
            alteracao: false,    
            dataPontoAlteracao: '', 
            abrangencias1: '',
            abrangencias2: '',              
          }
      },
      methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        /**
         * 
         * @param {*} dados 
         */
        processar(dados) {           
          this.ocorrenciaService = new OcorrenciaService();
          this.controlePontoService = new ControlePontoService();
          this.dados = dados; 
          this.buscarItemSolicitacao();         
        },
         /**
         * 
         * @param {*} solicitacao 
         */
         buscarItemSolicitacao() {           
            let requisicao = {
              idSolicitacao: this.dados.solicitacao.id,
              idFuncionario: this.dados.solicitacao.funcionario.id,
              dataPonto: this.formartarStrData(this.dados.solicitacao.dataPonto, 'US'),
              usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.ocorrenciaService.buscarItemSolicitacao(requisicao)
            .then(resp => {         
              const abrangencias = ['Falta', 'Falta de marcação', 'Atraso', 'Saída antecipada', 'Excesso no int. da refeição'];
              this.itemPendente = resp.data;
              this.itemPendente.infoCampo1.split(',').forEach((teste, index) => {
                if(teste === 'true') {
                    if(!this.abrangencias1) {
                        this.abrangencias1 += abrangencias[index]; 
                    } else {
                        this.abrangencias1 += ', ' + abrangencias[index];
                    }
                }
              });
              const solicitacao = this.dados.solicitacao;
              if (solicitacao.status === 'Pendente' && this.dados.permissaoEditar) {
                this.exibirBotoes = true;
              } else {
                this.acaoSelecionada = solicitacao.status;
              }
              if(!solicitacao.observacao) {
                this.dados.solicitacao.observacao = '';
              }
              this.observacaoNaoAprovado = solicitacao.observacao;  
              if(this.itemPendente.acao === 'ATUALIZAR') {
                this.titulo = 'Solicitação | Ocorrência | Atualizar';
                this.novo = false;
                this.alteracao = true;
                this.itemPendente.infoCampo2.split(',').forEach((teste, index) => {
                    if(teste === 'true') {
                        if(!this.abrangencias2) {
                            this.abrangencias2 += abrangencias[index]; 
                        } else {
                            this.abrangencias2 += ', ' + abrangencias[index];
                        }
                    }
                });
                this.dataPontoAlteracao =  this.formartarStrData(this.itemPendente.infoCampo3, 'BR');
              } else if(this.itemPendente.acao === 'EXCLUIR') {
                this.titulo = 'Solicitação | Ocorrência | Excluir';             
                this.novo = false;         
                this.alteracao = false;      
              } else {
                this.titulo = 'Solicitação | Ocorrência | Novo';
                this.novo = true; 
                this.alteracao = false;             
              }
              this.exibirModal = true;
            })
            .catch(erro => {exibirMensagem(this, erro)});           
        },
        /**
         * 
         */
        salvar() { 
          if(this.acaoSelecionada == '') {
            exibirMensagemSis(this, 'Selecione uma ação', true);
            return;
          }
          if(this.acaoSelecionada === this.naoAprovado 
            && this.observacaoNaoAprovado === '') {
            exibirMensagemSis(this, 'Informe um texto breve na observação', true);
            return;
          }         
          let solicitacao = clonar(this.dados.solicitacao);
          delete solicitacao.funcionario;
          solicitacao.status = this.acaoSelecionada;
          solicitacao.observacao = this.observacaoNaoAprovado;
          solicitacao['usuarioAprovacao'] = this.dados.requisicao.usuarioRequisicao.usuario.nome;             
          if(solicitacao.origem === 'OCORRENCIA') {           
            if(this.itemPendente.acao == 'NOVO') {              
              this.resolverPendenciaNovo(solicitacao);
            } else if(this.itemPendente.acao == 'ATUALIZAR') {
              this.resolverPendenciaAlteracao(solicitacao);
            } else if(this.itemPendente.acao == 'EXCLUIR') {
              this.resolverPendenciaExcluir(solicitacao);
            }
          } else {// CTRL_OCORRENCIA
            if(this.itemPendente.acao == 'NOVO') {              
              this.resolverPendenciaCTRLNovo(solicitacao);
            } else if(this.itemPendente.acao == 'EXCLUIR') {
              this.resolverPendenciaCTRLExcluir(solicitacao);
            }
          }   
        },
        /**
         * 
         */
        resolverPendenciaNovo(solicitacaoAtualizar) {  
          const abrangencias = this.itemPendente.infoCampo1.split(',');    
          const novaRequisicao = {
            cnpj: this.dados.requisicao.cnpj,
            solicitacao: solicitacaoAtualizar,
            ocorrencia: {         
                abrangeFaltas: (abrangencias[0] === 'true' ? true : false),
                abrangeFaltaMarcacao: (abrangencias[1] === 'true' ? true : false),
                abrangeAtrasos: (abrangencias[2] === 'true' ? true : false),
                abrangeSaidaAntecipada: (abrangencias[3] === 'true' ? true : false),
                abrangeExcessoRefeicao: (abrangencias[4] === 'true' ? true : false),     
                usuarioJustificativa: this.itemPendente.infoCampo2,
                observacao: this.itemPendente.observacao
            },
            justificativa: this.itemPendente.justificativa,
            dataInicio: this.formartarStrData(solicitacaoAtualizar.dataPonto, 'US'),
            dataFinal: this.formartarStrData(solicitacaoAtualizar.dataPonto, 'US'),
            funcionarios: [this.dados.solicitacao.funcionario],
            usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
          }
          this.ocorrenciaService.resolverPendenciaNovo(novaRequisicao)
          .then(resp => {
            this.fechar(); 
            exibirMensagem(this, resp);	  
            this.callback(solicitacaoAtualizar);
          })
          .catch(erro => {exibirMensagem(this, erro)});  
        },
        /**
         * 
         */
         resolverPendenciaAlteracao(solicitacaoAtualizar) {  
          const abrangencias = this.itemPendente.infoCampo2.split(',');           
          const novaRequisicao = {
            cnpj: this.dados.requisicao.cnpj,
            solicitacao: solicitacaoAtualizar,
            ocorrencia: {   
                id: this.itemPendente.idReferencia1,
                dia: this.itemPendente.infoCampo3,       
                abrangeFaltas: (abrangencias[0] === 'true' ? true : false),
                abrangeFaltaMarcacao: (abrangencias[1] === 'true' ? true : false),
                abrangeAtrasos: (abrangencias[2] === 'true' ? true : false),
                abrangeSaidaAntecipada: (abrangencias[3] === 'true' ? true : false),
                abrangeExcessoRefeicao: (abrangencias[4] === 'true' ? true : false),     
                usuarioJustificativa: this.itemPendente.infoCampo4,
                observacao: this.itemPendente.observacao
            },
            justificativa: this.itemPendente.justificativa,
            funcionario: this.dados.solicitacao.funcionario,
            usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
          }
          this.ocorrenciaService.resolverPendenciaAlteracao(novaRequisicao)
          .then(resp => {
            this.fechar(); 
            exibirMensagem(this, resp);	  
            this.callback(solicitacaoAtualizar);
          })
          .catch(erro => {exibirMensagem(this, erro)});  
        },
        /**
         * 
         */
         resolverPendenciaExcluir(solicitacaoAtualizar) {        
          const novaRequisicao = {
            cnpj: this.dados.requisicao.cnpj,
            solicitacao: solicitacaoAtualizar,
            ocorrencia: {   
                id: this.itemPendente.idReferencia1,
                dia: this.formartarStrData(solicitacaoAtualizar.dataPonto, 'US')                
            },     
            funcionario: this.dados.solicitacao.funcionario,       
            usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
          }
          this.ocorrenciaService.resolverPendenciaExcluir(novaRequisicao)
          .then(resp => {
            this.fechar(); 
            exibirMensagem(this, resp);	  
            this.callback(solicitacaoAtualizar);
          })
          .catch(erro => {exibirMensagem(this, erro)});  
        },        
        /**
         * 
         */
         resolverPendenciaCTRLExcluir(solicitacaoAtualizar) { 
          const data = this.formartarStrData(solicitacaoAtualizar.dataPonto, 'US');         
          const novaRequisicao = {
            solicitacao: solicitacaoAtualizar,
            diaPonto: data,           
            idFuncionario: this.dados.solicitacao.funcionario.id,
            usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
          }
          this.controlePontoService.resolverMarcarOcorrenciaExcluirPendente(novaRequisicao)
          .then(resp => {
            this.fechar(); 
            exibirMensagem(this, resp);	  
            this.callback(solicitacaoAtualizar);
          })
          .catch(erro => {exibirMensagem(this, erro)});  
        },
        /**
         * 
         * @param {*} strData 
         * @param {*} formato 
         */
         formartarStrData(strData, formato) {   
            if(formato == 'BR') {
                let partes = strData.split('-');
                return partes[2] + '/' + partes[1] + '/' + partes[0];
            }
            let partes = strData.split('/');
            return partes[2] + '-' + partes[1] + '-' + partes[0]; 
        },
        /**
         * 
         */
        fechar() {
          this.exibirModal = false; 
          this.itemPendente = null;          
          this.observacaoNaoAprovado = '';
          this.dados = null;
          this.acaoSelecionada = ''; 
          this.exibirBotoes = false; 
          this.controlePontoService = null;
          this.ocorrenciaService = null;
          this.abrangencias1 = '';
          this.abrangencias2 = '';
          this.titulo = 'Solicitação';
          this.novo = false;
          this.alteracao = false    
          this.dataPontoAlteracao = ''; 
        }       
      }
  }
  </script>
  
  <style scoped>
    .input-readonly {
      background-color: #F2F2F2;
    }
  </style>